import { OptimizedAppointmentResult } from "@/Appointments/Models/OptimizedAppointment/OptimizedAppointmentResult";
import { PredefinedAppointmentItem } from "./PredefinedAppointmentItem";

class PredefinedAppointmentGroup {
    public MaxStart: string;
    public MaxEnd: string;

    public IsOptimizedSearch: boolean;

    // Optimized Search
    public OptmizedResult: OptimizedAppointmentResult;

    // Old Search
    public PredefinedAppointments: { [keyValue: string]: PredefinedAppointmentItem[] };

    constructor() {
        this.PredefinedAppointments = {};
    }
}

export { PredefinedAppointmentGroup };
